import {Badge} from "@mantine/core";
import {PaymentIntentStatus} from "../types";

export const StatusBadge = ({status}: { status: string }) => {

    const colors = {
        [PaymentIntentStatus.canceled]: '#6c757d',
        [PaymentIntentStatus.processing]: '#007bff',
        [PaymentIntentStatus.requiresAction]: '#28a745',
        [PaymentIntentStatus.requiresCapture]: '#dc3545',
        [PaymentIntentStatus.requiresConfirmation]: '#ffc107',
        [PaymentIntentStatus.requiresPaymentMethod]: '#17a2b8',
        [PaymentIntentStatus.succeeded]: '#28a748'
    } as { [key: string]: string }


    return <Badge color={colors[status]}>{status}</Badge>;

};

